/**
 * Build a `delta` prop for SummaryCard from a trend API response.
 * Returns null when no trend data is available so the badge is hidden.
 *
 * Includes absolute current / previous values so the badge can render a tooltip.
 */
export const deltaForKey = (trendData, key) => {
  if (!trendData?.deltas?.[key]) return null;
  const d = trendData.deltas[key];
  return {
    pct: d.pct,
    current: d.current,
    previous: d.previous,
    vs_label: trendData.vs_label,
  };
};
